import { gql } from '@apollo/client';

export const fetchJobsTableDataQuery = gql`
  query fetchJobs(
    $filterInfo: JobFilterInfoInput
    $pagination: Pagination
    $sort: JobSortInfoInput
  ) {
    jobs(filterInfo: $filterInfo, pagination: $pagination, sort: $sort) {
      info {
        count
        offset
        limit
        page
      }
      results {
        id
        recurringJobId
        jobTypeName
        createdAt
        scheduledStartTime
        endTime
        jobData
        jobState
        organizationId
        projectId
      }
    }
  }
`;
